<template>
  <div class="form-module">
    <div class="container">
      <div class="title">查找</div>
      <button class="close-btn" @click="sendDataToParent('close')">×</button>
    </div>
    <div class="form-container">
      <div class="form">
        <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="物探点号" class="coordinateEditor">
            <div class="search-container">
              <!-- 搜索框 -->
              <a-input v-model="searchQuery" placeholder="请输入搜索内容" @input="handleSearch" />

              <!-- 悬浮的搜索结果列表 -->
              <div v-if="searchResults.length > 0" class="floating-results">
                <a-list :dataSource="searchResults" bordered class="results-list">
                  <a-list-item v-for="item in searchResults" :key="item.intuitionPoint" class="result-item"
                    @click="handleSelect(item)">
                    {{ item.intuitionPoint }}
                  </a-list-item>
                </a-list>
              </div>
            </div>
          </a-form-model-item>
          <a-form-model-item label="关联管线" class="coordinateEditor">
            <a-switch default-checked v-model="relevance">
              <a-icon slot="checkedChildren" type="check" />
              <a-icon slot="unCheckedChildren" type="close" />
            </a-switch>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div class="form-buttons">
        <a-button style="margin-right: 10px;" @click="resetForm">取消</a-button>
        <a-button type="primary" @click="onSubmit">确定</a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QueryModule',
  props: {
    currentProjectId: String, //当前对象
  },
  data () {
    return {
      form: {},
      fuzzyQueryUrl: '/gis-manager/diagramming/point/fuzzy/queries/',
      relevanceLineUrl: '/gis-manager/diagramming/pipe/associated/pipeline/',
      relevance: true,
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      searchQuery: '', // 搜索框输入内容
      searchResults: [], // 搜索结果列表
    };
  },
  methods: {
    // 发送给父组件信息
    sendDataToParent (item) {
      this.$emit('qeury-to-parent', item);
    },
    // 重置表单
    resetForm () {
      this.sendDataToParent('close');
    },
    // 提交表单
    onSubmit () {
      console.log(this.relevance);

      if (this.relevance) {
        this.$http.get(this.relevanceLineUrl + this.currentProjectId + '/' + this.searchQuery).then(res => {
          this.sendDataToParent({
            type: 'query',
            data: this.searchQuery,
            line: res.data
          });
        })
        return;
      }
      this.sendDataToParent({
        type: 'query',
        data: this.searchQuery
      });
    },
    // 处理搜索输入
    async handleSearch () {
      if (this.searchQuery.trim() === '') {
        this.searchResults = [];
        return;
      }
      try {
        this.$http.get(this.fuzzyQueryUrl + this.currentProjectId + '/' + this.searchQuery).then(res => {
          this.searchResults = res.data
        })
      } catch (error) {
        console.error('搜索失败:', error);
      }
    },
    // 处理选择列表项
    handleSelect (item) {
      this.searchQuery = item.intuitionPoint; // 将选中的内容赋值给输入框
      this.searchResults = []; // 清空搜索结果列表
    },
  },
};
</script>

<style lang="less" scoped>
.form-module {
  padding: 2px 9px;
  // caret-color: transparent;
}

/* 容器样式 */
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
}

.title {
  flex: 1;
  font-size: 15px;
  padding-left: 10px;
}

.close-btn {
  cursor: pointer;
  font-size: 25px;
  color: #5e5c5c;
  background: none;
  border: none;
  padding: 0 7px;
}

.close-btn:hover {
  color: #c00;
}

/* 表单容器 */
.form-container {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  height: 200px;
  /* 固定高度 */
  overflow: hidden;
  /* 隐藏外部盒子的滚动条 */
}

/* 表单内容 */
.form {
  flex: 1;
  overflow-y: hidden;
  /* 隐藏表单内容的滚动条 */
  overflow-x: hidden;
  padding-left: 10px;
}

/* 底部按钮 */
.form-buttons {
  padding: 10px;
  border-top: 1px solid #ccc;
  text-align: right;
}

/deep/ .ant-form-item-label>label {
  font-size: 12px;
}

.picker {
  min-width: 162px !important;
  width: 150px;
}

.dropdown {
  position: absolute;
  z-index: 1000;
  width: 150px;
  background-color: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 200px;
  overflow-y: auto;

  .dropdown-radio {
    position: sticky;
    top: 0;
    width: 100%;
    overflow-x: auto;
  }

  .radio-group {
    display: flex;
    flex-wrap: wrap;
  }

  .radio-button {
    flex: 1 1 50%;
    box-sizing: border-box;
    text-align: center;
    line-height: 30px;
  }
}

.coordinateEditor {
  margin: 0;
}

/* 搜索容器 */
.search-container {
  position: relative;
}

/* 悬浮的搜索结果列表 */
.floating-results {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 1000;
  margin-top: 5px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 列表样式 */
.results-list {
  max-height: 90px;
  /* 限制列表的最大高度 */
  overflow-y: auto;
  /* 列表超出时显示滚动条 */
}

/* 列表项样式 */
.result-item {
  padding: 5px 12px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.result-item:hover {
  background-color: #f5f5f5;
}
</style>